import React, { FC } from 'react';
import MuiListItemIcon, { ListItemIconProps as MuiListItemIconProps } from '@material-ui/core/ListItemIcon';
import { Uds } from '../../types';

export type ListItemIconProps = Uds<MuiListItemIconProps & {}>;

export const ListItemIcon: FC<React.PropsWithChildren<ListItemIconProps>> = ({ dataTest, ...props }) => (
  <MuiListItemIcon data-test={dataTest} {...props} />
);
